export const CNE_GA_EVENT_ID = 1242;
export const CNE_GA_FILTER_DEPARTMENT_ID = 31505;
export const CNE_GA_TARGET_DEPARTMENT_ID = 32437;
